import {
  getCouponById,
  updateCouponById,
} from "../../../Redux/Coupon/CouponActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import validator from "../../../Util/validator";
import styles from "./EditCoupon.module.scss";
import moment from "moment";

function EditCoupon() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { updateCouponByIdLoading, couponById, couponByIdLoading } =
    useSelector((state: RootState) => state.coupons);
  const [name, setName] = useState<string>("");
  const [percent, setPercent] = useState<string>("");
  const [maxDiscount, setMaxDiscount] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [voucherType, setVoucherType] = useState<string>("");
  const [voucherLimit, setVoucherLimit] = useState<string>("");
  const [errors, setErrors] = useState<{
    name: string;
    percent: string;
    startDate: string;
    endDate: string;
    voucherType: string;
    maxDiscount: string;
    voucherLimit: string;
  }>({
    name: "",
    percent: "",
    startDate: "",
    endDate: "",
    voucherType: "",
    maxDiscount: "",
    voucherLimit: "",
  });

  const updateCouponHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const { errors: fieldErrors, isValid } = validator([
      {
        key: "name",
        value: name,
        type: "text",
      },
      {
        key: "percent",
        value: percent,
        type: "numberOnly",
        range: "0-100",
      },
      {
        key: "voucherLimit",
        value: voucherLimit,
        type: "numberOnly",
      },
      {
        key: "startDate",
        value: startDate,
        type: "date",
      },
      {
        key: "endDate",
        value: endDate,
        type: "date",
      },
      {
        key: "voucherType",
        value: voucherType,
        type: "text",
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });
    if (isValid) {
      if (!updateCouponByIdLoading) {
        const successHandler = () => {
          navigate("/admin/coupons", {
            replace: true,
          });
          toastHelper.success("Coupon updated successfully");
        };
        dispatch(
          updateCouponById({
            id: id || "",
            name,
            percent: parseInt(percent),
            maxDiscount: parseInt(maxDiscount || "0"),
            startDate,
            endDate,
            voucherType: parseInt(voucherType),
            voucherLimit: parseInt(voucherLimit),
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (couponById) {
      setName(couponById?.name || "");
      setPercent(couponById?.percent?.toString() || "0");
      setMaxDiscount(couponById?.maxDiscount?.toString() || "");
      setStartDate(moment(couponById?.startDate).format("YYYY-MM-DD") || "");
      setEndDate(moment(couponById?.enddate).format("YYYY-MM-DD") || "");
      setVoucherType(couponById?.voucherType?.toString() || "");
      setVoucherLimit(couponById?.voucherlimit?.toString() || "");
    }
  }, [couponById]);

  useEffect(() => {
    if (id) {
      dispatch(getCouponById({ id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <React.Fragment>
      {updateCouponByIdLoading || (couponByIdLoading && <Loading />)}
      <div className={styles.mainContainer}>
        <Link
          to="/admin/coupons"
          replace
          className={styles.backButtonContainer}
        >
          <button className={styles.button}>
            <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
            Back to Buildings
          </button>
        </Link>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Edit Coupon</h1>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.formContainer}>
            <form className={styles.form}>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Name</p>
                <input
                  type="text"
                  className={styles.input}
                  value={name}
                  onChange={(e) => setName(e.target.value.replace(/\s/g, ""))}
                />
                <p className={styles.error}>{errors.name}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Percent</p>
                <input
                  type="text"
                  className={styles.input}
                  value={percent}
                  onChange={(e) => setPercent(e.target.value)}
                />
                <p className={styles.error}>{errors.percent}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Max Discount</p>
                <input
                  type="text"
                  className={styles.input}
                  value={maxDiscount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setMaxDiscount(value);
                    }
                  }}
                />
                <p className={styles.error}>{errors.maxDiscount}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Voucher Limit</p>
                <input
                  type="text"
                  className={styles.input}
                  value={voucherLimit}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setVoucherLimit(value);
                    }
                  }}
                />
                <p className={styles.error}>{errors.voucherLimit}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Start Date</p>
                <input
                  type="date"
                  className={styles.input}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <p className={styles.error}>{errors.startDate}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>End Date</p>
                <input
                  type="date"
                  className={styles.input}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
                <p className={styles.error}>{errors.endDate}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Voucher Type</p>
                <select
                  className={styles.input}
                  value={voucherType}
                  onChange={(e) => setVoucherType(e.target.value)}
                >
                  {!voucherType && (
                    <option value="">Select Voucher Type</option>
                  )}
                  <option value="1">Package</option>
                  <option value="2">Booking</option>
                </select>
                <p className={styles.error}>{errors.voucherType}</p>
              </div>
              <div className={styles.buttonContainer}>
                <button
                  type="submit"
                  className={styles.button}
                  onClick={updateCouponHandler}
                >
                  Update Coupon
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EditCoupon;
